import React from "react";
import { motion } from "framer-motion";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Industries = ({ industries }) => {
  const navigate = useNavigate();

  return (
    <section className="home-section-card industries-section">
      <div className="section-header section-header-row">
        <div>
          <span className="section-kicker">Explore sectors</span>
          <h2>Industries We Serve</h2>
          <p>
            Find business opportunities, partners, and community support across
            focused industry networks.
          </p>
        </div>
      </div>

      <div className="industry-grid">
        {industries.map((item, i) => (
          <motion.button
            key={item.route}
            type="button"
            className="industry-card premium"
            style={{ "--clr": item.color }}
            onClick={() => navigate(`/2.0/industry/${item.route}`)}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.35, delay: i * 0.03 }}
            whileHover={{ y: -6 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="industry-glow" />
            <span className="industry-icon">{item.icon}</span>
            <span className="industry-label">{item.label}</span>
            <ArrowForward className="industry-arrow" fontSize="small" />
          </motion.button>
        ))}
      </div>
    </section>
  );
};

export default Industries;
